<template>
  <div ref="guardiandashboard" class="w-full">
    <students @selectedStudent="selectedStudent" :isCardActive="isStudentsViewActive" @updateBreadcrumbs="updateBreadcrumbs"/>
    <subjects @selectedSubject="selectedSubject" :userDetails="selectedStudentData" :isCardActive="isSubjectsViewActive" @updateBreadcrumbs="updateBreadcrumbs"/>
    <modules @selectedModule="selectedModule" :userDetails="selectedStudentData" :isCardActive="isModulesViewActive" @updateBreadcrumbs="updateBreadcrumbs"/>
    <topics @selectedTopic="selectedTopic" :userDetails="selectedStudentData" :isCardActive="isTopicsViewActive" @updateBreadcrumbs="updateBreadcrumbs"/>
    <tasks @selectedTask="selectedTask" @updateBreadcrumbs="updateBreadcrumbs" :isCardActive="isTasksViewActive" :userDetails="selectedStudentData"/>
    <task-details :userDetails="selectedStudentData" :isCardActive="isTaskDetailViewActive" @updateBreadcrumbs="updateBreadcrumbs"/>
  </div>
</template>


<script>
import VueApexCharts from 'vue-apexcharts'
import Students from './components/Students.vue'
import Subjects from './components/Subjects.vue'
import Modules from './components/Modules.vue'
import Topics from './components/Topics.vue'
import Tasks from './components/Tasks.vue'
import TaskDetails from './components/TaskDetails.vue'
import DoubleSlider from './components/DoubleSlider.vue'
export default {
  name: "GuardianDashboard",
  components: {
    VueApexCharts,
    Students,
    DoubleSlider,
    Subjects,
    Modules,
    Topics,
    Tasks,
    TaskDetails
  },
  props: {
    subjectViewActive:{
      required:true,
      type:Boolean
    },

  },
  data() {
    return {
      isStudentsViewActive: true,
      isSubjectsViewActive: false,
      isModulesViewActive: false,
      isTopicsViewActive: false,
      isTasksViewActive: false,
      isTaskDetailViewActive: false,
      selectedStudentData:{},
      name: "GuardianDashboard",
    };
  },
  watch: {
    subjectViewActive:function(){
      if(this.subjectViewActive){
        this.selectedStudent(this.selectedStudentData);
      }
    }
  },
  computed: {
    
  },
  methods: {
    updateBreadcrumbs(method, breadcrumbsParam) {
      this.$emit("updateBreadcrumbs", method, breadcrumbsParam);
      this.scrollToNavbar();
    },
    selectedStudent(user){
      this.selectedStudentData = user;
      this.isStudentsViewActive = false;
      this.isModulesViewActive = false;
      this.isTopicsViewActive = false;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = false;
      this.isSubjectsViewActive = true;
      this.selectedStudentData.selectedSubject = {};
      this.updateBreadcrumbs("add", { text: `${user.name.toLowerCase()}`, clickFunction: "backToSubjects", icon: "UserIcon" });
    },
    selectedSubject(subject){
      this.isSubjectsViewActive = false;
      this.isStudentsViewActive = false;
      this.isTopicsViewActive = false;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = false;
      this.isModulesViewActive = true;
      this.updateBreadcrumbs("add", { text: `${subject.subjectName.toLowerCase()}`, clickFunction: "backToModules", icon: "CodesandboxIcon" });
    },
    selectedModule(module){
      this.isSubjectsViewActive = false;
      this.isStudentsViewActive = false;
      this.isModulesViewActive = false;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = false;
      this.isTopicsViewActive = true;
      this.updateBreadcrumbs("add", { text: `${module.moduleName.toLowerCase()}`, clickFunction: "backToTopics", icon: "DiscIcon" });
    },
    selectedTopic(topic){
      this.isSubjectsViewActive = false;
      this.isStudentsViewActive = false;
      this.isModulesViewActive = false;
      this.isTopicsViewActive = false;
      this.isTaskDetailViewActive = false;
      this.isTasksViewActive = true;
      this.updateBreadcrumbs("add", { text: `${topic.name.toLowerCase()}`, clickFunction: "backToTasks", icon: "EditIcon" });
    },
    selectedTask(task){
      this.isSubjectsViewActive = false;
      this.isStudentsViewActive = false;
      this.isModulesViewActive = false;
      this.isTopicsViewActive = false;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = true;
      this.updateBreadcrumbs("add", { text: `${task.name.toLowerCase()}`, clickFunction: "backToTasks", icon: "EditIcon" });
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in-out",
        offset: -20,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      this.$scrollTo(
        document.getElementById("navbarGlobal"),
        750,
        scrollOptions
      );
    },
  },
  created() {
    
  },
  mounted() {
    var progressString = localStorage.getItem("Guardian_Position");
    if(!progressString){
      return
    }
    var progress =  JSON.parse(progressString);
    this.selectedStudentData = progress;
    var activeCard = localStorage.getItem("Active_Card");
    if(!activeCard){
      return
    }
    switch (activeCard) {
      case "1":
        this.selectedStudent(progress);
        break;
      case "2":
        this.selectedStudent(progress);
        this.selectedSubject(progress.selectedSubject);
        break;
      case "3":
        this.selectedStudent(progress);
        this.selectedSubject(progress.selectedSubject);
        this.selectedModule(progress.selectedModule);
        break;
      case "4":
        this.selectedStudent(progress);
        this.selectedSubject(progress.selectedSubject);
        this.selectedModule(progress.selectedModule);
        this.selectedTopic(progress.selectedTopic);
        break;
      case "5":
        this.selectedStudent(progress);
        this.selectedSubject(progress.selectedSubject);
        this.selectedModule(progress.selectedModule);
        this.selectedTopic(progress.selectedTopic);
        this.selectedTask(progress.selectedTask);
        break;
      default:
        break;
    }
  }
};
</script>